import React, { useMemo, useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Grid, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from "react-i18next";
import { GET_CUSTOMER_LEDGER, GET_IMPORT_PRODUCT_GROUP_REPORT, } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../common/CustomLoader";
import CustomReport from "../common/CustomReport";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";

const title = "import product group report";

const ImportProductGroupReport = () => {
    const navigate = useNavigate();
    const [permission, setPermissions] = useState()
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])


    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: 'productsGroupName', header: 'Product Group Name', size: 150, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },

            {
                accessorKey: "totalQty",
                header: "Total Quantity",
                size: 100,
                tableStyle: { textAlign: "center" },
            },

            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                        <IconButton onClick={() => handleViewClick(row.original.productsGroupId)}>
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                ),
            },
        ],
        [permission]
    );
    const handleViewClick = (productsGroupId) => {
        navigate(`/app/reports/importproductgroupmonthlyreport/${productsGroupId}`);
    };

    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,

            };
            const response = await genericPost(GET_IMPORT_PRODUCT_GROUP_REPORT, payload, {
            });

            if (response.data.success && Array.isArray(response.data.productsGroup)) {
                const mappedData = response.data.productsGroup.map((item, index) => {
                    return {
                        index: (pageIndex * pageSize + index + 1).toString().padStart(2, "0"),
                        productsGroupId: item.productsGroupId,
                        productsGroupName: item.productsGroupName,
                        totalQty: Number(item.totalQty || 0).toFixed(2)

                    };
                });
                setData(mappedData);
                setRowCount(response.data.pagination?.totalRecords || 0);
            } else {
                setError("No import product group data found");
            }
        } catch (error) {
            setError("Error fetching import product group data");
            console.error("Error fetching import product group data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page, pageSize)
    }, [page, pageSize, token,])

    const defaultView = 'importproductgroupreport';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
            />
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)} />
            {!permission?.view && <AccessDenied />}

        </>
    );
};
export default ImportProductGroupReport;
